import { render } from "./Categories.vue?vue&type=template&id=3f9b0d08"
import script from "./Categories.vue?vue&type=script&lang=js"
export * from "./Categories.vue?vue&type=script&lang=js"

import "./Categories.vue?vue&type=style&index=0&id=3f9b0d08&lang=scss"
script.render = render

export default script